import React, { Component } from 'react';
import { MDCSelectFoundation } from '@material/select';
import { SelectControl } from './SelectControl';

export class FocusableSelect extends Component {
  constructor(props) {
    super(props);
    this.state = { selection: false };
  }

  componentDidUpdate() {
    const new_selection = this.selectApi && this.selectApi.foundation_.selectedIndex_ >= 0;
    if (this.state.selection != new_selection) {
      this.setState({ selection: new_selection });
    }
  }

  _handleApi(selectApi) {
    this.selectApi = selectApi;
  }

  _defaultFocus() {
    const { focusOption, options } = this.props;
    if (focusOption) {
      return options.indexOf(focusOption);
    } else {
      return 0;
    }
  }

  _onClick(e) {
    const { foundation_ } = this.selectApi;

    const focusIndex = foundation_.selectedIndex_ < 0 ? this._defaultFocus() : foundation_.selectedIndex_;

    if (!foundation_.adapter_.isMenuOpen()) {
      foundation_.disableScroll_();
      const { OPEN, LABEL_FLOAT_ABOVE, BOTTOM_LINE_ACTIVE } = MDCSelectFoundation.cssClasses;

      foundation_.setMenuStylesForOpenAtIndex_(focusIndex);
      foundation_.adapter_.addClassToLabel(LABEL_FLOAT_ABOVE);
      foundation_.adapter_.addClassToBottomLine(BOTTOM_LINE_ACTIVE);
      foundation_.adapter_.addClass(OPEN);
      foundation_.animationRequestId_ = requestAnimationFrame(() => {
        foundation_.adapter_.openMenu(focusIndex);
        foundation_.isFocused_ = true;
      });
    }
  }

  render() {
    const { focusOption, ...other } = this.props;
    const { selection } = this.state;

    const unchosen = selection ? '' : ' focusable-select-unchosen';

    return (
      <div className={`focusable-select${unchosen}`}>
        <SelectControl apiRef={selectApi => this._handleApi(selectApi)} {...other} />
        <div onClick={this._onClick.bind(this)} className="focusable-select-target" />
      </div>
    );
  }
}

export default FocusableSelect;
